import type { ImageInputConfig } from "@thisissoon/flitejs-frontend";

export const cardImageConfig: ImageInputConfig = {
  sources: [
    {
      size: "xl",
      width: 692,
      height: 864,
      resizeFill: true,
    },
    {
      size: "lg",
      width: 692,
      height: 864,
      resizeFill: true,
    },
    {
      size: "md",
      width: 320,
      height: 400,
      resizeFill: true,
    },
    {
      size: "xs",
      width: 312,
      height: 390,
      resizeFill: true,
    },
  ],
  fallback: {
    size: "fallback",
    width: 448,
    height: 560,
    resizeFill: true,
  },
};

export const smallCardImageConfig: ImageInputConfig = {
  sources: [
    {
      size: "xl",
      width: 320,
      height: 256,
      resizeFill: true,
    },
    {
      size: "lg",
      width: 258,
      height: 206,
      resizeFill: true,
    },
    {
      size: "md",
      width: 320,
      height: 256,
      resizeFill: true,
    },
    {
      size: "xs",
      width: 312,
      height: 250,
      resizeFill: true,
    },
  ],
  fallback: {
    size: "fallback",
    width: 320,
    height: 256,
    resizeFill: true,
  },
};

export const twoImageHeroConfig: ImageInputConfig = {
  sources: [
    {
      size: "xl",
      width: 828,
      height: 1035,
      resizeFill: true,
    },
    {
      size: "lg",
      width: 704,
      height: 880,
      resizeFill: true,
    },
    {
      size: "md",
      width: 564,
      height: 705,
      resizeFill: true,
    },
    {
      size: "xs",
      width: 320,
      height: 400,
      resizeFill: true,
    },
  ],
  fallback: {
    size: "fallback",
    width: 704,
    height: 880,
    resizeFill: true,
  },
};
